// extracted by mini-css-extract-plugin
export default {"container":"Form_container__mXxgm","heading":"Form_heading__dXfqf","form":"Form_form__cIc6e","label":"Form_label__nefhG"};